<template>
  <v-container fluid>
    <v-layout row wrap v-show="!showLoading">
      <v-flex xs12>
        <v-layout row wrap v-for="(item, index) in data_decimal" :key="index">
          <v-flex md2 sm2 xs5 pa-1>
            <v-text-field label="จากจำนวน" v-model="item.from_value"  hide-details/>
          </v-flex>
          <v-flex md1 sm1 xs1 pa-1>
            <h1 class="text-xs-center" style="padding-top: 0.5rem;">-</h1>
          </v-flex>
          <v-flex md2 sm2 xs5 pa-1>
            <v-text-field label="ถึงจำนวน" v-model="item.to_value"  hide-details/>
          </v-flex>
          <v-flex md1 sm1 xs1 pa-1>
            <h1 class="text-xs-center" style="padding-top: 0.5rem;">=</h1>
          </v-flex>
          <v-flex md2 sm2 xs4 pa-1>
            <v-text-field label="เท่ากับ" v-model="item.total_value"  hide-details/>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-2>
          <v-flex xs12>
            <v-btn color="success" @click="plusBox()">
              <v-icon :size="16">fa-plus</v-icon>
              <span class="ml-2">เพิ่มขั้น</span>
            </v-btn>
            <v-btn color="warning" @click="delBox()">
              <v-icon :size="16">fa-minus</v-icon>
              <span class="ml-2">ลดขั้น</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 text-xs-right>
        <v-btn color="success"  @click="onSave()">
          <v-icon>save</v-icon>
          <span class="px-2">{{ $t('save')}}</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import SettingService from "@/services/SettingService";

export default {
  data: () => ({
    data_decimal: [{ line: 1, from_value: 0, to_value: 0, total_value: 0 }]
  }),
  created: function() {
    this.commitSetToolbar({ patternTool: "2" });
    this.getDecimalSetting();
  },
  destroyed: function() {
    this.commitToggleAlertDialog({ status: false, message: Object });
  },
  computed: {
    ...mapState("app", ["showLoading"])
  },
  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    getDecimalSetting() {
      this.commitSetShowLoading(true);
      SettingService.getDecimalSetting()
        .then(res => {
          if (res.data.content.length > 0) {
            this.data_decimal = res.data.content;
          }
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    onSave() {
      SettingService.saveDecimal(this.data_decimal)
        .then(res => {
          this.getDecimalSetting();
          this.showLoading = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    plusBox() {
      var line = this.data_decimal.length + 1;
      this.data_decimal.push({
        line: line,
        from_value: 0,
        to_value: 0,
        total_value: 0
      });
    },
    delBox() {
      this.data_decimal.splice(-1, 1);
    }
  }
};
</script>

